// extracted by mini-css-extract-plugin
export default {"Captions":"Captions-module--Captions--gyobz","Captions__text":"Captions-module--Captions__text--XWHhx"};